import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ShipmentsPage from './pages/ShipmentsPage'
import ShipmentRequestsPage from './pages/ShipmentRequestsPage'
import ReceiverOptOutsPage from './pages/ReceiverOptOutsPage'
import CargoReturnsPage from './pages/CargoReturnsPage'
import JobsPage from './pages/JobsPage'
import JobOffersPage from './pages/JobOffersPage'
import UnifiedAccountsPage from './pages/UnifiedAccountsPage'
import DriversPage from './pages/DriversPage'
import VehiclesPage from './pages/VehiclesPage'
import PendingVerificationsPage from './pages/PendingVerificationsPage'
import DisputesPage from './pages/DisputesPage'
import FinancePage from './pages/FinancePage'
import PenaltiesPage from './pages/PenaltiesPage'
import MapsPage from './pages/MapsPage'
import CronJobsPage from './pages/CronJobsPage'
import SubscriptionsPage from './pages/SubscriptionsPage'
import SubscriptionPlansPage from './pages/SubscriptionPlansPage'
import EntitlementsPage from './pages/EntitlementsPage'
import CampaignsPage from './pages/CampaignsPage'
import BillingSettingsPage from './pages/BillingSettingsPage'
import ConfigPage from './pages/ConfigPage'
import ScoresPage from './pages/ScoresPage'
import SystemHealthPage from './pages/SystemHealthPage'
import MitigationPage from './pages/MitigationPage'
import NotificationsPage from './pages/NotificationsPage'
import SettingsPage from './pages/SettingsPage'
import ProtectedRoute from './components/ProtectedRoute'
import EnumLoader from './components/EnumLoader'

function App() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <EnumLoader />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/shipments" element={<ShipmentsPage />} />
                  <Route path="/shipment-requests" element={<ShipmentRequestsPage />} />
                  <Route
                    path="/draft-requests"
                    element={<ShipmentRequestsPage key="draft-requests" statuses={['DRAFT']} />}
                  />
                  <Route path="/mitigation" element={<MitigationPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/job-offers" element={<JobOffersPage />} />
                  <Route path="/receiver-sms-opt-outs" element={<ReceiverOptOutsPage />} />
                  <Route path="/cargo-returns" element={<CargoReturnsPage />} />
                  <Route path="/accounts" element={<UnifiedAccountsPage />} />
                  <Route path="/drivers" element={<DriversPage />} />
                  <Route path="/vehicles" element={<VehiclesPage />} />
                  <Route path="/maps" element={<MapsPage />} />
                  <Route path="/pending-verifications" element={<PendingVerificationsPage />} />
                  <Route path="/disputes" element={<DisputesPage />} />
                  <Route path="/finance" element={<FinancePage />} />
                  <Route path="/penalties" element={<PenaltiesPage />} />
                  <Route path="/subscriptions" element={<SubscriptionsPage />} />
                  <Route path="/subscription-plans" element={<SubscriptionPlansPage />} />
                  <Route path="/entitlements" element={<EntitlementsPage />} />
                  <Route path="/campaigns" element={<CampaignsPage />} />
                  <Route path="/billing-settings" element={<BillingSettingsPage />} />
                  <Route path="/cron-jobs" element={<CronJobsPage />} />
                  <Route path="/config" element={<ConfigPage />} />
                  <Route path="/scores" element={<ScoresPage />} />
                  <Route path="/system-health" element={<SystemHealthPage />} />
                  <Route path="/notifications" element={<NotificationsPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Box>
  )
}

export default App
